export default "__VITE_ASSET__Dn$vW9BI__"